import {initializeApp} from 'firebase/app';
import {getAnalytics, logEvent} from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyD5VUAnC1zQempyFJ2dj4Yh02_dnnonNHA",
  authDomain: "meprism-development.firebaseapp.com",
  projectId: "meprism-development",
  storageBucket: "meprism-development.firebasestorage.app",
  messagingSenderId: "367517752388",
  appId: "1:367517752388:web:4190a4e08d5c8508ebf011",
  measurementId: "G-BK7BHPSFV9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Function to log events
export const logFirebaseEvent = (eventName: string, eventParams?: Record<string, any>) => {
  logEvent(analytics, eventName, eventParams);
};